import styles from "./style.module.scss";

import { useState } from "react";
import DownArrow from "../icons/DownArrow";
import UpArrow from "../icons/UpArrow";
import AnimateHeight from "@components/shared/animateHeight";

export default function OneElement({
    title,
    content,
    elementClassName,
    onClickHandler,
    slug,
    url,
}: {
    title?: string;
    content?: { title: string | null; link: string }[];
    elementClassName?: string;
    onClickHandler?: CallableFunction;
    slug?: string;
    url: string;
}) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <>
            {(content?.length as number) > 0 && (
                <section className="mt-1 border-b pb-6 last-of-type:border-b-0 ">
                    <div
                        onClick={() => {
                            setIsOpen((prev) => !prev);

                            if (onClickHandler) {
                                onClickHandler();
                            }
                        }}
                        className={
                            elementClassName ??
                            `py-3 flex items-center justify-between cursor-pointer font-bold lg:font-normal`
                        }
                    >
                        <h3
                            className={` ${styles["mainTile"]}  lg:text-lg text-sm`}
                        >
                            {title}
                        </h3>
                        {isOpen ? <UpArrow /> : <DownArrow />}
                    </div>
                    <AnimateHeight height={isOpen ? "auto" : 0} duration={200}>
                        <div
                            className={`${styles["linksList"]} ${
                                slug &&
                                slug === "contents" &&
                                (content?.length as number) >= 3
                                    ? "max-h-[250px] overflow-y-auto  "
                                    : ""
                            }  lg:w-[217px]`}
                        >
                            {content?.map((el, index) => (
                                <div
                                    key={index}
                                    className={`${
                                        slug && slug === "contents"
                                            ? `${styles["bulletedListItem"]} pl-5  rtl:pr-4 before:rtl:right-[5px] before:ltr:left-[5px] `
                                            : ""
                                    } pb-3  `}
                                >
                                    <a
                                        href={
                                            el?.link.includes("#")
                                                ? `${url}${el.link}`
                                                : el?.link ?? "#"
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: el?.title as string,
                                        }}
                                        // onClick={() =>
                                        //     setModalVisibility(false)
                                        // }
                                        className={`${styles["linkColor"]}  before:rtl:right-[2px] before:ltr:left-[2px] block  cursor-pointer text-sm `}
                                    />
                                </div>
                            ))}
                        </div>
                    </AnimateHeight>
                </section>
            )}
        </>
    );
}
